(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ew-article-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('edwards-article')) {
    customElements.define('edwards-article', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.querySelectorAll('table').forEach(table => {
          let wrap = table.parentElement;
          if (wrap === this || !['DIV','FIGURE'].includes(wrap.tagName) || wrap.children.length > 1) {
            wrap = document.createElement('div');
            table.before(wrap);
            wrap.append(table);
          }
          wrap.classList.add('ew-article-table');
          wrap.tabIndex = 0;
          wrap.setAttribute('role', 'region');
          wrap.setAttribute('aria-label', table.caption?.textContent || this.dataset.tableLabel);
        });
        const headings = [...this.querySelectorAll('h2,h3')].filter(h => h.textContent.trim() && !h.closest('nav,aside,[hidden]'));
        const used = new Set([...document.querySelectorAll('[id]')].map(el => el.id));
        headings.forEach((h, index) => {
          if (!h.id) {
            const base = 'ew-heading-' + (index + 1);
            let id = base, n = 2;
            while (used.has(id)) id = base + '-' + n++;
            h.id = id;
            used.add(id);
          }
          if (!h.hasAttribute('tabindex')) h.tabIndex = -1;
        });
        if (headings.length < 3 || this.querySelector('nav[aria-label="' + this.dataset.tocLabel + '"], .ew-article-toc')) return;
        const nav = document.createElement('nav');
        nav.className = 'ew-article-toc';
        nav.setAttribute('aria-label', this.dataset.tocLabel);
        const details = document.createElement('details');
        details.open = !matchMedia('(max-width: 599px)').matches;
        const summary = document.createElement('summary');
        summary.textContent = this.dataset.tocLabel;
        const list = document.createElement('ul');
        let parent = null, childList = null;
        headings.forEach(h => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + encodeURIComponent(h.id);
          a.textContent = h.textContent.trim();
          a.setAttribute('allow-hash-change', '');
          a.addEventListener('click', event => {
            if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            event.stopPropagation();
            history.pushState(null, '', '#' + encodeURIComponent(h.id));
            h.focus({preventScroll: true});
            h.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
          });
          li.append(a);
          if (h.tagName === 'H2' || !parent) {
            list.append(li);
            parent = h.tagName === 'H2' ? li : null;
            childList = null;
          } else {
            if (!childList) {
              childList = document.createElement('ul');
              parent.append(childList);
            }
            childList.append(li);
          }
        });
        details.append(summary, list);
        nav.append(details);
        const first = headings[0];
        let block = first;
        while (block.parentElement !== this && block.parentElement) block = block.parentElement;
        block.before(nav);
        if (location.hash) {
          try {
            const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
            if (target && this.contains(target)) requestAnimationFrame(() => target.scrollIntoView({behavior:'instant', block:'start'}));
          } catch {}
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
